import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const GridColumn = (props) => {
    const {
        align,
        children,
        className,
    } = props;
    const columnClassName = classNames('grid__column', {
        [`grid__column--${align}`]: !!align,
    }, className);

    return (
        <div className={columnClassName}>
            {children}
        </div>
    );
};

GridColumn.propTypes = {
    align: PropTypes.oneOf(['', 'center', 'left', 'right']),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    className: PropTypes.string,
};

GridColumn.defaultProps = {
    align: '',
    className: '',
    children: () => <React.Fragment />,
};

export default GridColumn;
